import { render, staticRenderFns } from "./InactivateButton.vue?vue&type=template&id=992ef930&"
import script from "./InactivateButton.vue?vue&type=script&lang=js&"
export * from "./InactivateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports